import React from "react";
import "../../assets/css/common.scss";
import TextField from "@material-ui/core/TextField";
import Logo from "../../assets/img/logo.svg";
import Dropzone from "react-dropzone";
import PhotoUploadIcon from "../../assets/img/photouploadicon.svg";
import { REGISTER_PROFILE } from "../../utils/url-builder";
import { getUserId } from "../../utils/authentication-access";
import { post } from "../../utils/api-authentication";
import Snackbar from "@material-ui/core/Snackbar";
import BaseService from "../../store/services/base.service";

class RegisterProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      imagePreviewUrl: "",
      file: null,
      errmsg: " ",
      openerrmsg: false
    };
  }

  onFirstNameEnter(event) {
    this.setState({
      firstname: event.target.value,
      firstnameerrorText: "",
      firstnameerrorstatus: false
    });
  }

  onLastNameEnter(event) {
    this.setState({
      lastname: event.target.value,
      lastnameerrorText: "",
      lastnameerrorstatus: false
    });
  }

  dashboardPage = () => {
    this.props.history.push("/dashboard");
  };

  RegisterInstituteClick = () => {
    this.props.history.push("/register-institute");
  };

  registerClick = async () => {
    if (
      this.state.firstname === "" ||
      this.state.firstname.trim().length === 0
    ) {
      this.setState({ firstnameerrorstatus: true });
      this.setState({ firstnameerrorText: "Please enter First Name" });
    } else if (!this.state.firstname.charAt(0).match(/^[a-zA-Z0-9]+$/)) {
      this.setState({
        firstnameerrorstatus: true,
        firstnameerrorText: "First Character must be alphabet"
      });
    } else if (this.state.lastname === "") {
      this.setState({ lastnameerrorstatus: true });
      this.setState({ lastnameerrorText: "Please enter Last Name" });
    } else {
      const url = REGISTER_PROFILE.registerProfile(getUserId());
      const formData = new FormData();
      formData.append("file", this.state.file);
      formData.append("firstName", this.state.firstname);
      formData.append("lastName", this.state.lastname);
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };
      let res = await new BaseService().makePostRequestGeneric(
        url,
        formData,
        config.headers
      );
      this.setState({ data: res.data });
      this.props.history.push("/dashboard");
    }
  };

  confirmRead = () => {
    this.setState({ readdialogopen: false });
  };

  readClick = () => {
    this.setState({ readdialogopen: true });
  };

  onPicDrop = imagefile => {
    this.previewPic(imagefile[0]);
  };

  previewPic = file => {
    let reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    };
    if (file && file.type.match("image.*")) {
      reader.readAsDataURL(file);
    }
  };

  onPicSelect(event) {
    this.previewPic(event.target.files[0]);
  }

  onRemovePicClick = () => {
    const self = this;
    self.setState({ imagePreviewUrl: "" });
  };

  onEnterKeyPress = e => {
    if (e.key === "Enter") {
      this.registerClick();
    }
  };

  render() {
    return (
      <div>
        <div className="card signin-card">
          <div className="text-left mb-2">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="card-title">Personal Information</div>
          <p>Create your personal’s profile to proceed.</p>
          <div className="submenu-div-2">
            <Dropzone multiple={false} accept="image/*" onDrop={this.onPicDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="text-center">
                  <input {...getInputProps()} />
                  <img
                    alt="Upload profile pic"
                    style={
                      this.state.imagePreviewUrl
                        ? { height: 100, width: 100, borderRadius: 50 }
                        : {}
                    }
                    src={
                      this.state.imagePreviewUrl
                        ? this.state.imagePreviewUrl
                        : PhotoUploadIcon
                    }
                  />
                </div>
              )}
            </Dropzone>

            <div className="div-center">
              <label htmlFor="file-upload" className="uploadpic-button">
                Change
              </label>
              <input
                id="file-upload"
                className="file-type"
                type="file"
                accept="image/*"
                onChange={this.onPicSelect.bind(this)}
              />
              or
              <button
                className="remove-button"
                disabled={!this.state.imagePreviewUrl}
                onClick={this.onRemovePicClick}
              >
                {" "}
                remove{" "}
              </button>
            </div>
          </div>

          <TextField
            id="standard-firstname"
            label="First Name"
            className="input-field"
            margin="normal"
            value={this.state.firstname}
            FormHelperTextProps={fixHyperText}
            helperText={this.state.firstnameerrorText}
            error={this.state.firstnameerrorstatus}
            onChange={this.onFirstNameEnter.bind(this)}
            onKeyDown={this.onEnterKeyPress}
          />
          <TextField
            id="standard-lastname"
            label="Last Name"
            className="input-field"
            margin="normal"
            value={this.state.lastname}
            FormHelperTextProps={fixHyperText}
            helperText={this.state.lastnameerrorText}
            error={this.state.lastnameerrorstatus}
            onChange={this.onLastNameEnter.bind(this)}
            onKeyDown={this.onEnterKeyPress}
          />
          <button
            className="btn-button-learn mt-2 col-full"
            onClick={this.registerClick}
          >
            Continue
          </button>
        </div>

        <Snackbar
          message={this.state.errmsg}
          open={this.state.openerrmsg}
          onClose={() => this.setState({ openerrmsg: false })}
          autoHideDuration={2000}
        />
      </div>
    );
  }
}

const fixHyperText = {
  style: {
    position: "absolute",
    bottom: "-30%"
  }
};

export default RegisterProfile;
